export default __webpack_public_path__ + "static/media/kurtk4.09be1372.jpg";